import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { ContractContext } from '../contexts/ContractContext';
import SaveModal from '../modals/SaveModal';

export const useLogoHandler = () => {
    const history = useHistory();
    const location = useLocation();
    const context = useContext(ContractContext);
    const clientId = context.data?.clientId?.toLowerCase() || context.data?.contract?.clientId?.toLowerCase() || 'aig';
    const contractId = context.data?.contract?.contractId || '';
    const [showSaveClaimModal, setShowSaveClaimModal] = useState(false);
    const currentPathname = location.pathname || '';

    const onLogoClick = (e) => {
        e && e.preventDefault();

        if (contractId) {
            if (currentPathname === '/createnewpassword') {
                history.push('/plansearch');
            } else if (currentPathname.includes('/fileclaim/entitlement') || currentPathname === '/appointment') {
                setShowSaveClaimModal(true);
            } else if (
                currentPathname === '/faq'
                || currentPathname === '/coveragedocs'
                || currentPathname === '/info/contact-us'
                || currentPathname === '/fileclaim/confirmation'
                || currentPathname === '/customerDetails'
                || currentPathname === '/assetcoverageoverview'
                || currentPathname === '/contractoverview'
                || currentPathname?.toLowerCase() === '/detailsoverview'
                || currentPathname?.toLowerCase().includes('/contactconfirmation')
            ) {
                history.push('/planoverview');
            }
        } else {
            history.push('/plansearch', { showLoginPage: true });
        }
    };

    const onSaveCancel = (e) => {
        e && e.preventDefault();
        setShowSaveClaimModal(false);
    };

    const saveForLater = (e) => {
        e && e.preventDefault();

        const claim = history.location?.state?.claim;
        const party = history.location?.state?.entitlementDetails?.party;
        const contractAsset = history.location?.state?.entitlementDetails?.contractAsset;
        const coverageId = contractAsset?.contractAssetCoverageModel[0]?.coverageId;
        const model = { claimModel: claim, partyModel: party };

        let step = 0;

        if (currentPathname?.toLowerCase().includes('/fileclaim/entitlement')) {
            step = 1;
        } else if (currentPathname === '/fileclaim/verifyinfo') {
            step = 2;
        } else if (currentPathname === '/fileclaim/payment') {
            step = 3;
        } else if (currentPathname === '/appointment') {
            step = 5;
        }

        if (!claim || step === 0) {
            return;
        }

        fetch(`api/claim/SaveForLater/${claim?.claimId}/${step}/${false}/${clientId}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(model)
        }).then((data) => {
            if (data.status === 204) {
                setShowSaveClaimModal(false);
            }
            if (data.status === 200) {
                setShowSaveClaimModal(false);
                history.push('/fileclaim/confirmation', {
                    statusType: 'savedClaim',
                    clientId: clientId,
                    coverageId: coverageId,
                    claimNumber: claim?.claimNumber,
                    claimId: claim?.claimId,
                    contractAssetId: claim?.contractAssetId
                });
            }
        });
    };

    const SavePrompt = () =>
        showSaveClaimModal && (
            <SaveModal
                showConfirmation={showSaveClaimModal}
                aria-label={'Opens a modal to save your claim'}
                client={clientId}
                onCancel={onSaveCancel}
                onSaveForLaterAction={saveForLater}
            />
        );

    return { SavePrompt, onLogoClick };
};
